module.exports = __webpack_public_path__ + "static/logo-jurishand-white-956f9ba4f48603ad1cd7cd15216299df.svg";